<template>
  <section class="products-section">
    <div class="products-container">

      <header class="products-header">
        <span class="label-chip">Προϊόντα</span>
        <h2 class="products-heading">Έτοιμες Λύσεις για την Επιχείρησή σας</h2>
        <p class="products-subheading">
          Πέρα από custom κατασκευές, αναπτύσσουμε ολοκληρωμένες SaaS πλατφόρμες έτοιμες για χρήση.
        </p>
      </header>

      <div class="product-card">

        <div class="product-content">
          <div class="product-meta">
            <img class="product-logo" src="@/assets/CTGYM.YELLOW 1080x1080.svg" alt="Cloudtec Gym logo" />
            <div>
              <div class="product-name-row">
                <span class="product-name">Cloudtec <strong>Gym</strong></span>
                <span class="badge-new">Νέο</span>
              </div>
              <span class="product-type">SaaS Πλατφόρμα Γυμναστηρίου</span>
            </div>
          </div>

          <p class="product-description">
            Ολοκληρωμένο σύστημα διαχείρισης γυμναστηρίου — κρατήσεις, μέλη, πληρωμές,
            mobile app και push notifications σε μία πλατφόρμα. Χωρίς χαρτιά, χωρίς χάος.
          </p>

          <ul class="product-features">
            <li>
              <span class="feat-dot"></span>
              Admin Panel με dashboard, μέλη, κρατήσεις &amp; οικονομικά
            </li>
            <li>
              <span class="feat-dot"></span>
              Member App για Android &amp; iOS με QR check-in
            </li>
            <li>
              <span class="feat-dot"></span>
              Πλάνα συνδρομών, προγράμματα &amp; ατομικές προπονήσεις
            </li>
            <li>
              <span class="feat-dot"></span>
              Push notifications &amp; αυτόματες υπενθυμίσεις
            </li>
          </ul>

          <div class="product-actions">
            <router-link to="/products/cloudtec-gym" class="btn-primary">
              Δείτε το Προϊόν
            </router-link>
            <a href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener" class="btn-secondary">
              Ξεκινήστε Δωρεάν
            </a>
          </div>

          <div class="product-stores">
            <a href="https://play.google.com/store/apps/details?id=com.nvourlidas.ctgym"
               target="_blank" rel="noopener" class="store-badge">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91,3.34,2.39,3.84,2.15L13.69,12L3.84,21.85C3.34,21.6,3,21.09,3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08,20.75,11.5,20.75,12C20.75,12.5,20.5,12.92,20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              Google Play
            </a>
            <a href="https://apps.apple.com/gr/app/cloudtec-gym/id6757802948"
               target="_blank" rel="noopener" class="store-badge">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              App Store
            </a>
          </div>
        </div>

        <div class="product-visual">
          <div class="product-img-wrap">
            <img
              src="@/assets/CloudtecGym/Dashboard_widgets.png"
              alt="Cloudtec Gym - Admin Dashboard"
              class="product-screenshot"
              loading="lazy"
            />
          </div>
          <div class="product-status">
            <span class="status-dot"></span>
            Διαθέσιμο τώρα
          </div>
        </div>

      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductsSection',
}
</script>

<style scoped>
.products-section {
  padding: clamp(3rem, 6vw, 6rem) clamp(1rem, 4vw, 1.5rem);
  background-color: #1f2d3d;
}

.products-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* ── Header ── */
.products-header {
  text-align: center;
  margin-bottom: 2.4rem;
}

.label-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  border: 1px solid rgba(255, 201, 71, 0.35);
  background: rgba(255, 201, 71, 0.08);
  color: #FFC947;
  border-radius: 999px;
  padding: 0.3rem 0.9rem;
  margin-bottom: 0.7rem;
}

.products-heading {
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  font-weight: 800;
  color: #fff;
  margin: 0 0 0.6rem;
  overflow-wrap: break-word;
  word-break: break-word;
}

.products-subheading {
  max-width: 640px;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.72);
  font-size: 1.05rem;
  line-height: 1.65;
}

/* ── Product Card ── */
.product-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.5rem;
  align-items: center;
  background: linear-gradient(135deg, rgba(31, 45, 61, 0.98), rgba(37, 54, 73, 0.92));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: clamp(1.6rem, 4vw, 2.5rem);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  overflow: hidden;
}

.product-card:hover {
  border-color: rgba(47, 85, 212, 0.55);
  box-shadow: 0 20px 56px rgba(0, 0, 0, 0.4);
}

/* ── Content side ── */
.product-meta {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  margin-bottom: 1.1rem;
}

.product-logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
  flex-shrink: 0;
}

.product-name-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.product-name {
  font-size: 1.35rem;
  font-weight: 700;
  color: #fff;
}

.product-name strong {
  color: #FFC947;
}

.badge-new {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: rgba(255, 201, 71, 0.15);
  border: 1px solid rgba(255, 201, 71, 0.4);
  color: #FFC947;
  border-radius: 999px;
  padding: 0.15rem 0.55rem;
}

.product-type {
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 600;
  letter-spacing: 0.03em;
}

.product-description {
  color: rgba(255, 255, 255, 0.82);
  font-size: 1rem;
  line-height: 1.7;
  margin: 0 0 1.2rem;
}

.product-features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.product-features li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.95rem;
  line-height: 1.5;
}

.feat-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #FFC947;
  flex-shrink: 0;
  margin-top: 0.45em;
}

.product-actions {
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
  margin-bottom: 1.1rem;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(47, 85, 212, 0.95);
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.65rem 1.3rem;
  border-radius: 10px;
  border: 1px solid transparent;
  transition: background 0.2s, transform 0.2s;
}

.btn-primary:hover {
  background: rgba(47, 85, 212, 1);
  transform: translateY(-2px);
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: transparent;
  color: #FFC947;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.65rem 1.3rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 201, 71, 0.4);
  transition: background 0.2s, transform 0.2s;
}

.btn-secondary:hover {
  background: rgba(255, 201, 71, 0.08);
  transform: translateY(-2px);
}

.product-stores {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.store-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 0.35rem 0.75rem;
  transition: color 0.2s, border-color 0.2s;
}

.store-badge:hover {
  color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.3);
}

/* ── Visual side ── */
.product-visual {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.8rem;
}

.product-img-wrap {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
}

.product-screenshot {
  width: 100%;
  height: auto;
  display: block;
}

.product-status {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.55);
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.6);
  flex-shrink: 0;
}

/* ── Responsive ── */
@media (max-width: 860px) {
  .product-card {
    grid-template-columns: 1fr;
  }

  .product-visual {
    align-items: center;
    order: -1;
  }

  .product-img-wrap {
    max-width: 480px;
  }
}

@media (max-width: 540px) {
  .product-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    justify-content: center;
  }
}
</style>
